module.exports = __webpack_public_path__ + "img/search.d4d9674d.svg";